import {
  Briefcase,
  Building2,
  CircleHelp,
  Cookie,
  Factory,
  FileText,
  FolderTree,
  Globe,
  Image,
  Images,
  Layers,
  LayoutDashboard,
  List,
  Mail,
  MessageSquare,
  Newspaper,
  Package,
  PackageOpen,
  Phone,
  FlaskConical,
  ClipboardList,
  Presentation,
  ScrollText,
  Search,
  Shield,
  Star,
  Store,
  MapPin,
  Users,
  UserCheck,
} from "lucide-react";

const NAV_ICON_STROKE = 1.75;

const remToPx = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string" && value.endsWith("rem")) {
    return Math.round(parseFloat(value) * 16);
  }
  return 18;
};

export function createNavIcon(LucideIcon) {
  function NavIcon(props = {}) {
    const { sx, style, ...rest } = props;
    const size = remToPx(sx?.fontSize ?? style?.fontSize ?? "1.125rem");

    return (
      <LucideIcon
        size={size}
        strokeWidth={NAV_ICON_STROKE}
        color="currentColor"
        style={{ flexShrink: 0, display: "block", ...style }}
        aria-hidden
        {...rest}
      />
    );
  }

  NavIcon.__navLucide = true;
  NavIcon.displayName = `NavIcon(${LucideIcon.displayName || LucideIcon.name || "Icon"})`;

  return NavIcon;
}

export const NavDashboardIcon = createNavIcon(LayoutDashboard);
export const NavCareerIcon = createNavIcon(Briefcase);
export const NavCareerApplicationsIcon = createNavIcon(UserCheck);
export const NavProductIcon = createNavIcon(Package);
export const NavProductListIcon = createNavIcon(List);
export const NavProductCategoryIcon = createNavIcon(FolderTree);
export const NavApplicationIcon = createNavIcon(Layers);
export const NavIndustriesIcon = createNavIcon(Factory);
export const NavAllIndustriesIcon = createNavIcon(Building2);
export const NavPopularProductIcon = createNavIcon(Star);
export const NavMarketplaceIcon = createNavIcon(Store);
export const NavLocationsIcon = createNavIcon(MapPin);
export const NavDefaultProductsIcon = createNavIcon(PackageOpen);
export const NavSeoIcon = createNavIcon(Search);
export const NavMediaGroupIcon = createNavIcon(Presentation);
export const NavMediaExhibitionIcon = createNavIcon(Images);
export const NavExhibitionBannerIcon = createNavIcon(Image);
export const NavBannerImagesIcon = createNavIcon(Image);
export const NavLeadsIcon = createNavIcon(Users);
export const NavTalkToExpertIcon = createNavIcon(Phone);
export const NavExportEnquiryIcon = createNavIcon(Globe);
export const NavQuoteRequestIcon = createNavIcon(ClipboardList);
export const NavSampleRequestIcon = createNavIcon(FlaskConical);
export const NavNewsletterIcon = createNavIcon(Mail);
export const NavContentIcon = createNavIcon(Newspaper);
export const NavContactUsIcon = createNavIcon(MessageSquare);
export const NavFaqIcon = createNavIcon(CircleHelp);
export const NavBlogIcon = createNavIcon(FileText);
export const NavBlogAuthorIcon = createNavIcon(UserCheck);
export const NavOurTeamIcon = createNavIcon(Users);
export const NavPrivacyIcon = createNavIcon(Shield);
export const NavTermsIcon = createNavIcon(ScrollText);
export const NavCookiesIcon = createNavIcon(Cookie);
